import React from 'react'
import {
  Card,
  Row,
  Col,
  Statistic,
  Table,
  Button,
  Space,
  Divider,
} from 'antd'
import { ArrowUpOutlined, DownloadOutlined, PrinterOutlined } from '@ant-design/icons'
import { useModulePermission } from '@/hooks/useModulePermission'
import '../Lead/LeadList.css'

const PAndLReport: React.FC = () => {
  const { canDownload } = useModulePermission('Reports')
  return (
    <div className="lead-list-container">
      <div className="list-header">
        <h2>Profit & Loss Report</h2>
        <Space>
          {canDownload && <Button icon={<DownloadOutlined />}>Export Excel</Button>}
          <Button icon={<PrinterOutlined />}>Print</Button>
        </Space>
      </div>

      <Card>
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={12}>
            <h3 style={{ marginBottom: '16px' }}>Income</h3>
            <div style={{ paddingLeft: '16px' }}>
              <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                <span>Generator Revenue</span>
                <strong>₹290,000</strong>
              </div>
              <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                <span>Consumer Revenue</span>
                <strong>₹345,000</strong>
              </div>
              <Divider style={{ margin: '12px 0' }} />
              <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between' }}>
                <strong>Total Income</strong>
                <strong style={{ color: '#3f8600', fontSize: '16px' }}>
                  ₹635,000
                </strong>
              </div>
            </div>

            <h3 style={{ marginBottom: '16px', marginTop: '24px' }}>Expenses</h3>
            <div style={{ paddingLeft: '16px' }}>
              <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                <span>Employee Expenses</span>
                <strong>₹15,000</strong>
              </div>
              <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                <span>Operational Expenses</span>
                <strong>₹12,000</strong>
              </div>
              <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between' }}>
                <span>Other Expenses</span>
                <strong>₹8,000</strong>
              </div>
              <Divider style={{ margin: '12px 0' }} />
              <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between' }}>
                <strong>Total Expenses</strong>
                <strong style={{ color: '#cf1322', fontSize: '16px' }}>
                  ₹35,000
                </strong>
              </div>
            </div>
          </Col>

          <Col xs={24} lg={12}>
            <Card className="kpi-card">
              <div style={{ textAlign: 'center', padding: '16px' }}>
                <Statistic
                  title="Net Profit / Loss"
                  value={600000}
                  prefix="₹"
                  suffix={
                    <ArrowUpOutlined
                      style={{
                        color: '#3f8600',
                        marginLeft: '8px',
                      }}
                    />
                  }
                  valueStyle={{
                    color: '#3f8600',
                    fontSize: '32px',
                  }}
                />
              </div>
            </Card>

            <Card className="kpi-card" style={{ marginTop: '16px' }}>
              <Statistic
                title="Profit Margin"
                value={94.49}
                suffix="%"
                valueStyle={{ color: '#3f8600' }}
              />
            </Card>

            <Card className="kpi-card" style={{ marginTop: '16px' }}>
              <Statistic
                title="Operating Expense Ratio"
                value={5.51}
                suffix="%"
                valueStyle={{ color: '#faad14' }}
              />
            </Card>
          </Col>
        </Row>

        <Divider />

        <h3>Monthly P&L Trend</h3>
        <Table
          dataSource={[
            {
              key: '1',
              month: 'June 2024',
              income: 330000,
              expenses: 18000,
              profit: 312000,
            },
            {
              key: '2',
              month: 'May 2024',
              income: 305000,
              expenses: 17000,
              profit: 288000,
            },
          ]}
          columns={[
            { title: 'Month', dataIndex: 'month', key: 'month' },
            {
              title: 'Income (₹)',
              dataIndex: 'income',
              key: 'income',
            },
            {
              title: 'Expenses (₹)',
              dataIndex: 'expenses',
              key: 'expenses',
            },
            {
              title: 'Net Profit (₹)',
              dataIndex: 'profit',
              key: 'profit',
              render: (value: number) => <strong>₹{value}</strong>,
            },
          ]}
          pagination={false}
        />
      </Card>
    </div>
  )
}

export default PAndLReport
